import script from "./BrandLivery.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandLivery.vue?vue&type=script&setup=true&lang=js"

import "./BrandLivery.vue?vue&type=style&index=0&id=3e85cd43&scoped=true&lang=scss"

import exportComponent from "/Users/kadir.aslan/Projects/Repositories/Personal/kadiraslan-de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e85cd43"]])

export default __exports__